function get_comment_time_difference(date_string) {
  const date = new Date(date_string);
  const now = new Date();
  const diff_ms = now - date;

  return ({
    date,
    diff_sec: Math.floor(diff_ms / 1000),
    diff_min: Math.floor(diff_ms / 60000),
    diff_hour: Math.floor(diff_ms / 3600000),
    diff_day: Math.floor(diff_ms / 86400000),
  });
}

function format_comment_time_unit(value, label) {
  return `${value} ${label}${value === 1 ? "" : "s"} ago`;
}

function get_recent_comment_time_entries(time_difference) {
  return [
    {
      matches: time_difference.diff_sec < 60,
      label: "Just now",
    },
    {
      matches: time_difference.diff_min < 60,
      label: format_comment_time_unit(time_difference.diff_min, "min"),
    },
    {
      matches: time_difference.diff_hour < 24,
      label: format_comment_time_unit(time_difference.diff_hour, "hour"),
    },
    {
      matches: time_difference.diff_day < 7,
      label: format_comment_time_unit(time_difference.diff_day, "day"),
    },
  ];
}

function get_recent_comment_time_label(time_difference) {
  return get_recent_comment_time_entries(time_difference).find((entry) => entry.matches)?.label || "";
}

function format_comment_full_date(date) {
  return date.toLocaleDateString("en-ZA", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function get_personal_comment_profile_picture(comment = {}) {
  return comment?.base_profile?.user?.profile?.profile_files?.find(
    (file) => file?.profile_file_type === "profile_picture"
  )?.file?.url || null;
}

function get_business_comment_profile_picture(comment = {}) {
  return comment?.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.file_url
    || comment?.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.url
    || null;
}

export function format_comment_time_ago(date_string) {
  if (!date_string) {
    return "";
  }

  const time_difference = get_comment_time_difference(date_string);
  const recent_label = get_recent_comment_time_label(time_difference);

  return recent_label || format_comment_full_date(time_difference.date);
}

export function get_comment_profile_picture(comment = {}) {
  return comment?.base_profile?.profile_type === "personal"
    ? get_personal_comment_profile_picture(comment)
    : get_business_comment_profile_picture(comment);
}

export const campaign_date_field_methods = {
  get_today_date() {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${today.getFullYear()}-${month}-${day}`;
  },
  get_campaign_start_date_max() {
    return this.campaign_form?.end_date || "";
  },
  get_campaign_end_date_min() {
    const today = this.get_today_date();
    const start_date = this.campaign_form?.start_date || "";

    if (!start_date) {
      return today;
    }

    return start_date > today ? start_date : today;
  },
  validate_campaign_date_fields() {
    this.validate_campaign_form();
  },
};
